import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import Card from 'dashboard/components/card/Card';
import FixedPlugin from 'dashboard/components/fixedPlugin/FixedPlugin';

function AuthCentered(props) {
  const { children, title, description, cardTop, cardBottom } = props;
  return (
    <Stack
      direction='column'
      alignSelf='center'
      justifySelf='center'
      sx={{ overflow: 'hidden', mx: { xs: '10px', lg: 0 }, minHeight: '100vh' }}
    >
      <FixedPlugin />
      <Box
        sx={{
          position: 'absolute',
          minHeight: { xs: '50vh', md: '50vh' },
          maxHeight: { xs: '50vh', md: '50vh' },
          width: { md: 'calc(100vw)' },
          maxWidth: { md: 'calc(100vw)' },
          left: 0,
          right: 0,
          top: 0,
          background: 'linear-gradient(to bottom, #7551FF, #422AFB)',
          mx: { md: 'auto' },
        }}
      />
      <Card
        sx={{
          width: { xs: '100%', md: 'max-content' },
          mx: 'auto',
          maxWidth: '100%',
          mt: cardTop,
          mb: cardBottom,
          p: { xs: '10px', md: '50px' },
          pt: { xs: '30px', md: '50px' },
          position: 'relative',
          zIndex: 1,
        }}
      >
        {title && description && (
          <Stack
            direction='column'
            textAlign='center'
            justifyContent='center'
            alignItems='center'
            mt='125px'
            mb='30px'
          >
            <Typography variant='h4' color='#fff' fontWeight='bold'>
              {title}
            </Typography>
            <Typography
              color='#fff'
              fontWeight='normal'
              mt='10px'
              mb='26px'
              sx={{ width: { xs: '90%', sm: '60%', lg: '40%', xl: '333px' } }}
            >
              {description}
            </Typography>
          </Stack>
        )}
        {children}
      </Card>
    </Stack>
  );
}

AuthCentered.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string,
  image: PropTypes.any,
};

export default AuthCentered;
